import React from 'react';
import CloseIcon from '@mui/icons-material/Close';
import { Box, Divider, IconButton } from '@mui/material';

import { createScrollbarStyling } from '@paragon/themes';
import { assertExhaustiveSwitch } from '@paragon/utilities';

import { hasPermissionToViewCheckResults } from '../../../store/selectors/rightToolbarSelectors';
import { leftSidebarSet } from '../../../store/slices/panelDataSlice';
import { useAppDispatch, useAppSelector } from '../../hooks';
import AnalysisHistoryPanel from '../../interface/panels/AnalysisHistoryPanel';
import CheckResultsPanel from '../../interface/panels/CheckResultsPanel';
import LoadCasesPanel from '../../interface/panels/LoadCasesPanel';
import ExplorerPanel from '../../interface/panels/navigation-panel/ExplorerPanel';
import { ScheduleLineGroupPanel } from '../../interface/panels/navigation-panel/ScheduleLineGroupPanel';
import { NotificationsPanel } from '../../interface/panels/NotificationsPanel';
import CheckResultsShortcuts from '../../interface/subpanels/elements/CheckResultsShortcuts';
import { MissingEngineeringVariablesNotification } from '../../interface/subpanels/elements/MissingEngineeringVariablesNotification';

export function LeftSidebarContents() {
  const dispatch = useAppDispatch();

  const showCheckResults = useAppSelector(hasPermissionToViewCheckResults);

  const status = useAppSelector((state) => state.panelData.leftSidebar);

  switch (status) {
    case 'closed':
      return null;

    case 'analysisHistory':
      return (
        <>
          <Box sx={{ display: 'flex', justifyContent: 'flex-end', padding: 1 }}>
            <IconButton onClick={() => void dispatch(leftSidebarSet('open'))}>
              <CloseIcon />
            </IconButton>
          </Box>

          <Divider />

          <AnalysisHistoryPanel />

          {showCheckResults && (
            <>
              <Divider />

              <CheckResultsShortcuts />

              <Box sx={[{ flex: 1, minHeight: 0, overflowY: 'auto' }, createScrollbarStyling]}>
                <LoadCasesPanel />
                <CheckResultsPanel />

                <MissingEngineeringVariablesNotification />
              </Box>
            </>
          )}
        </>
      );

    case 'notifications':
      return <NotificationsPanel />;

    case 'open':
    case 'default':
    case 'negateDefault':
      return (
        <>
          <ScheduleLineGroupPanel />
          <ExplorerPanel />
        </>
      );

    default:
      assertExhaustiveSwitch(status);
  }
}
